import { render, staticRenderFns } from "./SocialMediaMobileView.vue?vue&type=template&id=45127bae&scoped=true&"
import script from "./SocialMediaMobileView.vue?vue&type=script&lang=js&"
export * from "./SocialMediaMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45127bae",
  null
  
)

export default component.exports